import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
} from "./types";
  
import AuthService from "../services/auth.service";

export const register = (primernombre, segundonombre, primerapellido, segundoapellido, fechadenacimiento, 
  curp, telefonomovil, arean1, arean2, imageprofile, bio, genero, email, password, confirmpassword, roles) => (dispatch) => {
  
    return AuthService.register(primernombre, segundonombre, primerapellido, segundoapellido, fechadenacimiento, 
    curp, telefonomovil, arean1, arean2, imageprofile, bio, genero, email, password, confirmpassword, roles).then(
    (response) => {
      dispatch({
        type: REGISTER_SUCCESS,
      });
  
      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });
  
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
  
      dispatch({
        type: REGISTER_FAIL,
      });
  
      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });
  
      return Promise.reject();
    }
  );
};
  
export const login = (username, password) => (dispatch) => {
  return AuthService.login(username, password).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });      
      //CurrUser = data;
      //console.log(CurrUser);
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
  
      dispatch({
        type: LOGIN_FAIL,
      });
  
      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });
  
      return Promise.reject();
    }
  );
};
  
export const logout = () => (dispatch) => {
  AuthService.logout()  
  dispatch({
    type: LOGOUT,
  });

  return Promise.resolve();
};

export const changepsw = (iduser,currpassword,newpassword) => (dispatch) => {
  return AuthService.changepsw(iduser,currpassword,newpassword).then(
    (response) => {
      dispatch({
        type: SET_MESSAGE,
        payload: response.message,
      });

      return Promise.resolve();
  })
};

export const resetpsw = (requesteriduser, iduser,newpassword) => (dispatch) => {
  return AuthService.resetpsw(requesteriduser, iduser,newpassword).then(
    (response) => {
      dispatch({
        type: SET_MESSAGE,
        payload: response.message,
      });

      return Promise.resolve();
  })
};
